import { Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { SharePage } from './pages/SharePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AppShell } from './components/AppShell';

export function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/share/:roomId" element={<SharePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}
